// extracted by mini-css-extract-plugin
export default {"groupsModal":"GroupsManagerModal_groupsModal__mV32U","groupModalContent":"GroupsManagerModal_groupModalContent__2NcKs"};